import React, { useContext, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, FormikHelpers } from 'formik';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

import { ResearchSheet } from 'types';
import { PageKey } from 'enums';
import {
  BreadcrumbsCtx,
  initialBreadcrumbs,
} from 'components/portfolio/breadcrumbs-ctx';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { ReworkCtx } from 'components/rework-ctx/rework-ctx';

import { putResearchSheetRework } from './research-sheet-api';
import { ResearchSheetBasic } from './research-sheet-basic';
import { validationSchemaRework } from './research-sheet-validation';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
    },
    form: {
      color: 'black',
      marginBottom: 50,
    },
  })
);

export function ResearchSheetRework() {
  const classes = useStyles();
  const { setBreadcrumbs } = useContext(BreadcrumbsCtx);
  const { showNotification } = useContext(NotificationCtx);
  const { researchSheet, clearContext } = useContext(ReworkCtx);
  const history = useHistory();

  if (!researchSheet) {
    history.push('/portfolio/badatelske-listy');
  }

  const handleSubmit = async (
    values: ResearchSheet,
    actions: FormikHelpers<ResearchSheet>
  ) => {
    try {
      const response = await putResearchSheetRework(values);

      if (response) {
        showNotification('Žádost odeslána.', NotificationVariant.SUCCESS);

        actions.resetForm();

        clearContext?.();
        history.push('/portfolio/badatelske-listy');
      }
    } catch (e) {
      showNotification(
        'Žádost se nezdařilo odeslat.',
        NotificationVariant.ERROR
      );
    }

    actions.setSubmitting(false);
  };

  useEffect(() => {
    setBreadcrumbs([
      ...initialBreadcrumbs.breadcrumbs,
      {
        title: 'Přepracování BL',
        key: PageKey.PORTFOLIO_RESEARCH_SHEET_REWORK,
      },
    ]);
  }, [setBreadcrumbs]);

  // Clear context if user leaves rework page
  useEffect(() => {
    return () => {
      clearContext?.();
    };
  }, [clearContext]);

  return (
    <Grid container className={classes.container}>
      <Grid item xs={10} md={8}>
        <div className={classes.form}>
          <Formik<ResearchSheet>
            initialValues={researchSheet!}
            onSubmit={handleSubmit}
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            validationSchema={validationSchemaRework}
          >
            {ResearchSheetBasic}
          </Formik>
        </div>
      </Grid>
    </Grid>
  );
}
